<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="REINCORPORACIONES" key="1">
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  ref="master"
                  @action="masterAction"
                  @params="paramsTable"
                  :beforeSend="master.beforeSend"
                  :useMultipart="true"
                  modalWidth="95%"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Trabajador')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados"
                          ref="trabajador"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Días de incapacidad')">
                  <a-input-number style="width: 100%"
                                  readOnly
                                  v-decorator="['disability_days', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Origen')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['origin', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="id_h_origin"
                >
                </g-dropdown>
              </a-col>
              <a-divider orientation="left">
                Exámen postincapacidad
              </a-divider>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha exámen')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['post_disability_date', { rules: [{ required: false}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('IPS')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            ref="ipsList"
                            :decorator="['ips', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="id_h_ips"
                >
                </g-dropdown>
              </a-col>
              <a-col v-if="mostrarOtraIps" v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('¿Cuál?')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['other_ips', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-divider orientation="left">
                Tipo reintegro
              </a-divider>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha reintegro')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['refund_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Tipo reintegro')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['refund_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="id_h_refund_type"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Recomendaciones')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['recommendations', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-divider orientation="left">
                Vigencia
              </a-divider>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Días vigencia')">
                  <a-input-number style="width: 100%"
                                  readOnly
                                  :disabled="true"
                                  v-decorator="['days', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha inicio')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['init_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha fin')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['end_date', { rules: [{ required: false}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-divider orientation="left">
                Reinducción
              </a-divider>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha HSEQ')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['hseq_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha propia cargo')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['own_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-divider orientation="left">
                Prueba de trabajo
              </a-divider>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha trabajo')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['proof_date', { rules: [{ required: false}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Responsable trabajo')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['responsable', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Conclusiones trabajo')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['conclusions', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-divider/>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Seg. reincorporacion')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['reinstatement_follow', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha seguimiento')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['reinstatement_date', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Visita domiciliaria')" :has-feedback="false">
                  <a-checkbox v-decorator="['home_visit', {valuePropName: 'checked'}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Estado')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['status', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="id_h_status"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Responsable reintegro')"
                          ref="responsable_reintegro"
                          :formItemConfig="fiOptions"
                          endpoint="empleados"
                          :params="{filtra_por_cargo: true}"
                          :decorator="['reinstatment_responsable', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Obs. generales')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['general_remarks', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions" v-if="$getConfigValue('AGREGAR_CAMPO_FECHA_CARGUE_OPCION_REINCORPORACION', 'NO') === 'SI'">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha Cargue Acta de Reintegro')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD"
                                 v-decorator="['date_upload_doc', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Adjuntar actas de reintegro')">
                  <a-upload
                    :before-upload="beforeUpload"
                    :fileList="master.uploads.profileFile"
                    :remove="() => { master.uploads.profileFile = [] }">
                    <a-button style="width: 100%">Seleccionar archivo</a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import Mensajes from '../../Util/Mensajes'
  import HttpUtil from '../../../../util/HttpUtil'

  export default {
    data () {
      return {
        loadingBtns: {},
        mostrarOtraIps: false,
        paramsT: {},
        endpointExcel: 'reincorporaciones/downloadExcel',
        fileNameExcel: 'Reincorporaciones',
        fechaInicio: null,
        fechaFin: null,
        id_h_origin: {
          h_lookup_type: 'REINCORPORACIONES_ORIGEN'
        },
        id_h_ips: {
          h_lookup_type: 'REINCORPORACIONES_IPS'
        },
        id_h_refund_type: {
          h_lookup_type: 'REINCORPORACIONES_TIPO_REINTEGRO'
        },
        id_h_status: {
          h_lookup_type: 'REINCORPORACIONES_ESTADO'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 8},
        master: {
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            console.log("dataa", data)
            if (this.master.uploads.profileFile.length > 0) {
              data.file = this.master.uploads.profileFile[0]
            }
            return data
          },
          endpoint: 'ss_reinstatment',
          tableSetup: {
            actions: {
              width: 150,
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar acta',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Fecha de creación', dataIndex: 'created_on_desc', sorter: true},
              {title: 'Trabajador', dataIndex: 'nombre_completo_trabajador', sorter: true},
              {title: 'Doc. identidad', dataIndex: 'cedula_empleado', sorter: true},
              {title: 'Días incapacidad', dataIndex: 'disability_days', sorter: true},
              {title: 'Origen', dataIndex: 'origen', sorter: true},
              {title: 'Fecha postincapacidad', dataIndex: 'fecha_postincapacidad', sorter: true},
              {title: 'IPS', dataIndex: 'ips_desc', sorter: true},
              {title: 'Fecha reintegro', dataIndex: 'fecha_refund', sorter: true},
              {title: 'Tipo reintegro', dataIndex: 'refund', sorter: true},
              {title: 'Recomendaciones', dataIndex: 'recommendations', sorter: true},
              {title: 'Días vigencia', dataIndex: 'days', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'fecha_inicio', sorter: true},
              {title: 'Fecha fin', dataIndex: 'fecha_fin', sorter: true},
              {title: 'Fecha por parte HSEQ', dataIndex: 'fecha_hseq', sorter: true},
              {title: 'Fecha propia del cargo', dataIndex: 'fecha_propio', sorter: true},
              {title: 'Seguimiento reincorporación', dataIndex: 'reinstatement_follow', sorter: true},
              {title: 'Fecha seguimiento', dataIndex: 'reinstatement_date', sorter: true},
              {title: 'Fecha prueba trabajo', dataIndex: 'fecha_trabajo', sorter: true},
              {title: 'Responsable', dataIndex: 'responsable', sorter: true},
              {title: 'Conclusiones', dataIndex: 'conclusions', sorter: true},
              {title: 'Visita domiciliaria', dataIndex: 'visita_domiciliaria', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true},
              {title: 'Responsable reintegro', dataIndex: 'responsable_reintegro', sorter: true},
              {title: 'Observaciones generales', dataIndex: 'general_remarks', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    },
    methods: {
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      paramsTable (params) {
        this.paramsT = params
      },
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
        }

        switch (action.action) {
          case 'masterCreate':
            this.fechaInicio = null
            this.fechaFin = null
            this.mostrarOtraIps = false
            break
          case 'masterEdit':
            this.fechaInicio = null
            this.fechaFin = null
            if (!JsUtils.isEmpty(action.record.id_emp)) {
              this.$refs.trabajador && this.$refs.trabajador.handleSearch(action.record.id_emp)
            }
            if (!JsUtils.isEmpty(action.record.responsable_reintegro)) {
              this.$refs.responsable_reintegro && this.$refs.responsable_reintegro.handleSearch(action.record.reinstatment_responsable)
            }
            if (!JsUtils.isEmpty(action.record.responsable)) {
              this.$refs.responsable && this.$refs.responsable.handleSearch(action.record.responsable)
            }
            if (!this.$isEmpty(action.record.end_date) && !this.$isEmpty(action.record.init_date)) {
              this.fechaInicio = new Date(action.record.init_date)
              this.fechaFin = new Date(action.record.end_date)
            }
            if (!this.$isEmpty(action.record.codigo_ips)) {
              if (action.record.codigo_ips === 'OTR') {
                this.mostrarOtraIps = true
                setTimeout(() => {
                  this.$refs.master.modal.form.setFieldsValue({
                    other_ips: action.record.other_ips
                  })
                }, 300)
              } else {
                this.mostrarOtraIps = false
              }
            }
            break
          case 'download':
            this.downloadFile(action.record)
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.init_date)) {
              if (action.changedFields.init_date.value) {
                this.fechaInicio = new Date(action.changedFields.init_date.value)
                if (!this.$isEmpty(this.fechaFin) && (this.fechaFin > this.fechaInicio)) {
                  const resta = this.fechaFin.getTime() - this.fechaInicio.getTime()
                  this.$refs.master.modal.form.setFieldsValue({
                    days: Math.round(resta / (1000 * 60 * 60 * 24)) + 1
                  })
                } else {
                  this.$refs.master.modal.form.setFieldsValue({
                    days: 0
                  })
                }
              } else {
                this.$refs.master.modal.form.setFieldsValue({
                  days: null
                })
              }
            }
            if (!JsUtils.isEmpty(action.changedFields.end_date)) {
              if (action.changedFields.end_date.value) {
                this.fechaFin = new Date(action.changedFields.end_date.value)
                if (!this.$isEmpty(this.fechaInicio) && (this.fechaFin > this.fechaInicio)) {
                  const resta = this.fechaFin.getTime() - this.fechaInicio.getTime()
                  this.$refs.master.modal.form.setFieldsValue({
                    days: Math.round(resta / (1000 * 60 * 60 * 24)) + 1
                  })
                } else {
                  this.$refs.master.modal.form.setFieldsValue({
                    days: 0
                  })
                }
              } else {
                this.$refs.master.modal.form.setFieldsValue({
                  days: null
                })
              }
            }

            if (!this.$isEmpty(action.changedFields.ips)) {
              let valorSeleccionado = this.$refs.ipsList.options.filter(item => item.value == action.changedFields.ips.value)
              if (valorSeleccionado.length > 0) {
                let ips = valorSeleccionado[0]
                this.mostrarOtraIps = ips.code === 'OTR'
              } else {
                this.mostrarOtraIps = false
              }
            }
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('ss_reinstatment_/download', {
          id: record.id
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/Reincorporaciones.vue